import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaShoppingCart } from 'react-icons/fa';
import { useCart } from './CartContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { cartItems } = useCart();
  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="fixed top-0 left-0 z-50 w-full p-4 text-white shadow-lg bg-gradient-to-r from-blue-600 to-blue-800">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold tracking-tight">Libro Nest</Link>
          </div>
          <div className="items-center hidden space-x-6 md:flex">
            {['Books', 'Authors', 'Customers', 'Orders'].map((item) => (
              <Link
                key={item}
                to={`/${item.toLowerCase()}`}
                className="px-4 py-2 font-medium transition-all rounded-lg hover:bg-blue-700"
              >
                {item}
              </Link>
            ))}
            <Link
              to="/cart"
              className="relative flex items-center px-4 py-2 transition-all rounded-lg hover:bg-blue-700"
            >
              <FaShoppingCart className="mr-2" />
              Cart
              {cartCount > 0 && (
                <span className="absolute flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full -top-2 -right-2">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>
          <div className="flex items-center md:hidden">
            <button onClick={toggleMenu} className="focus:outline-none" aria-label="Toggle menu">
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="px-4 pb-4 bg-blue-700 md:hidden">
          {['Books', 'Authors', 'Customers', 'Cart', 'Orders'].map((item) => (
            <Link
              key={item}
              to={`/${item.toLowerCase()}`}
              onClick={toggleMenu}
              className="block px-4 py-2 transition-all rounded-lg hover:bg-blue-600"
            >
              {item}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;